// extracted by mini-css-extract-plugin
export default {"resendCode":"EmailVerification_resendCode__FpsPl","sentCode":"EmailVerification_sentCode__lTEkt"};